import React from "react";

import jupiterImage from "../../assets/media/jupiter.png";
import cylleneImage from "../../assets/media/cyllene.png";
import bloggerzImage from "../../assets/media/bloggerz.png";
import bloodhelpImage from "../../assets/media/blood-help.png";

import "./works.css";
const Works = () => {
  return (
    <div className=" container works">
      <div className="header">Works</div>
      <p>You can see my works below.</p>
      {/* 1 */}
      <div className="subHeader">Jupiter</div>
      <div className="row">
        <div className="col s12 m12 l6 xl6">
          {" "}
          It is a social networking platform.
          <br />
        </div>
        <div className="col s12 m12 l6 xl6">
          <img src={jupiterImage} alt="Jupiter app" />
        </div>
        <div className="col s12 m12 l6 xl6">
          <br />
          <b>User stories :</b>
          <ul>
            <li> User can login/signup. </li>
            <li> User can search other users and follow or unfollow them. </li>
            <li> User can view his or her or other user's profile.</li>
            <li> User can post updates which appear at home section.</li>
            <li> User can like posts and comment on posts.</li>
          </ul>
          <div className="buttons">
            <a
              href="https://aa1aac-jupiter.glitch.me/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Live{" "}
            </a>

            <a
              href="https://github.com/aa1aac/Jupiter"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Source Code
            </a>
          </div>
        </div>

        <div className="col s12 m12 l6 xl6">
          <div className="technologies row">
            <b>Technologies used : </b>

            <div className="span">MongoDB</div>

            <div className="span">Express</div>
            <div className="span">React</div>

            <div className="span">Redux</div>
            <span className="span">Nodejs</span>
            <span className="span">Mongoose</span>
          </div>
        </div>
      </div>

      <hr />

      {/* 2 */}

      <div className="subHeader">Cyllene</div>
      <div className="row">
        <p className="col s12 m6 l6 xl6"> It is a Q&A platform</p>
        <div className="col s12 m6 l6 xl6">
          <img src={cylleneImage} alt="cyllene app" />
        </div>
        <div className="col s12 m6 l6 xl6">
          <br />
          <b>User Stories : </b>
          <ul>
            <li>User can login/signup.</li>
            <li>User can view previously asked questions.</li>
            <li>User can search for previously asked questions.</li>
            <li>User can ask new questions through dashboard.</li>
            <li>User can answer other questions.</li>
          </ul>
          <div className="buttons">
            <a
              href="https://aa1aac-cyllene-5.glitch.me/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Live{" "}
            </a>

            <a
              href="https://github.com/aa1aac/cyllene"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Source Code
            </a>
          </div>
        </div>

        <div className="col s12 m6 l6 xl6">
          <div className="technologies row">
            <b>Technologies used : </b>

            <div className="span">MongoDB</div>

            <div className="span">Express</div>
            <div className="span">React</div>

            <div className="span">Context API</div>
            <span className="span">Nodejs</span>
            <span className="span">Mongoose</span>
          </div>
        </div>
      </div>

      <hr />
      {/* 3 */}

      <div className="subHeader">Bloggerz</div>
      <div className="row">
        <p className="col s12 m6 l6 xl6"> It is a blogging app</p>
        <div className="col s12 m6 l6 xl6">
          <img src={bloggerzImage} alt="Bloggerz app" />
        </div>
        <div className="col s12 m6 l6 xl6">
          <br />
          <b>User Stories : </b>
          <ul>
            <li>User can view blogs.</li>
            <li>User can create blogs after creating account.</li>
            <li>User can delete and edit his/her blog.</li>
            <li>User can comment on blog posts.</li>
          </ul>
          <div className="buttons">
            <a
              href="https://bloggerzz.herokuapp.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Live{" "}
            </a>

            <a
              href="https://github.com/aa1aac/bloggerz"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Source Code
            </a>
          </div>
        </div>

        <div className="col s12 m6 l6 xl6">
          {" "}
          <div className="technologies row">
            <b>Technologies used : </b>

            <div className="span">MongoDB</div>

            <div className="span">Express</div>
            <div className="span">React</div>

            <div className="span">Context API</div>
            <span className="span">Nodejs</span>
            <span className="span">Mongoose</span>
          </div>
        </div>
      </div>

      <hr />

      {/* 4 */}
      <div className="subHeader">Blood help</div>
      <div className="row">
        <div className="col s12 m6 l6 xl6">
          {" "}
          <p>I created this app in chingu collab.</p>
        </div>

        <div className="col s12 m6 l6 xl6">
          <img src={bloodhelpImage} alt="Blood help app" />
        </div>

        <div className="col s12 m6 l6 xl6">
          <br />
          <b>User Stories : </b>
          <ul>
            <li>
              User can view the number of blood donors in the platform by blood
              group in dashboard.
            </li>
            <li>User can search filter people by blood groups.</li>
            <li>User can ask for blood help through email adress.</li>
            <li>User can have pagination in the filter.</li>
          </ul>
          <div className="buttons">
            <a
              href="https://blood-help.herokuapp.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Live{" "}
            </a>

            <a
              href="https://github.com/aa1aac/blood-help"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              View Source Code
            </a>
          </div>
        </div>

        <div className="col s12 m6 l6 xl6">
          {" "}
          <div className="technologies row">
            <b>Technologies used : </b>

            <div className="span">MongoDB</div>

            <div className="span">Express</div>
            <div className="span">EJS</div>
            <span className="span">Nodejs</span>
            <span className="span">Mongoose</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Works;
